import React from 'react';
import { Form, Row, Col, Alert } from 'antd';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';
import AddRole from './AddRole';
import EditRole from './EditRole';
import axios from 'axios';

import apiPath from 'apiPath';

class RoleManager extends React.Component {

    state = {
        selectedRole: null
    }

    handleAddSubmit = (values) => {
        axios.post(apiPath + '/adminRole/addRole', values, { withCredentials: true }).then(result => {
            this.props.getRole();
        })
    }


    handleEditSubmit = (event) => {
    }


    getSelectedRole = (event) => {
        this.setState({ selectedRole: event.target.id })
    }

    render() {

        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <br />
                <br />
                <Alert showIcon type="info"
                    style={{ margin: '20pt' }}
                    message=""
                    description={
                        <p>Add a role and then select it from the table to edit permissions</p>
                    } />
                <Row style={{ paddingTop: '10pt' }}>
                    <Col span={10}>
                        {getFieldDecorator('name', {
                        })(
                            <AddRole onSubmit={this.handleAddSubmit} Roles={this.props.Roles} getSelectedRole={this.getSelectedRole} />
                        )}
                    </Col>
                    <Col span={12}>
                        <EditRole Access={this.state.Access} onSubmit={this.handleEditSubmit} selectedRole={this.state.selectedRole} />
                    </Col>
                </Row>
            </div>
        )
    }
}

export default Form.create()(RoleManager);



// WEBPACK FOOTER //
// ./portal-components/Portal/AdminRole/RoleManager.jsx